import { i18n, LANGUAGES } from "./internationalize/i18n.service";
import styles from "./local-nav.style.scss?raw";

export class LocalNavComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Inject styles into the document head
        if (!document.getElementById('local-nav-styles')) {
            const styleElement = document.createElement('style');
            styleElement.id = 'local-nav-styles';
            styleElement.textContent = styles;
            document.head.appendChild(styleElement);
        }

        this.innerHTML = `
            <nav>
                <a href='/'><h1>The Big Whale</h1></a>
                <div class="nav-links-container">
                    <tbw-dark-mode-switcher></tbw-dark-mode-switcher>
                    <button id="auth-btn">Trigger authChange Event</button>
                    <button id="lang-switcher-btn" class="lang-switcher"></button>

                </div>
                <ul>
                    <li><a href="/">Home</a></li>
                    <li><a href="/src/tests/tbw-newsletter-form">Newsletter</a></li>
                    <li><a href="/src/tests/homepage">Homepage</a></li>
                    
                </ul>
            </nav>
        `;

        // Set active state based on current page
        this.setActiveNavItem();
        this.createAuthTriggerButton();
        this.createLanguageSwitcher();
    }

    createAuthTriggerButton(): void {
        const authBtn = this.querySelector('#auth-btn') as HTMLButtonElement;
        authBtn?.addEventListener('click', function (e) {
            console.log('click auth btn')
            const customEvent = new CustomEvent('authChange', {
                detail: { authenticated: true },
                bubbles: true,
                cancelable: true
            });

            document.dispatchEvent(customEvent);
        });
    }

    createLanguageSwitcher(): void {
        const langBtn = this.querySelector('#lang-switcher-btn') as HTMLButtonElement;
        if (!langBtn) return;

        // Update button text based on current language
        const currentLang = localStorage.getItem('wglang')
        langBtn.textContent = currentLang === LANGUAGES.EN ? '🇬🇧 EN' : '🇫🇷 FR';

        // Handle language switching
        langBtn.addEventListener('click', () => {
            const currentLang = i18n.getLanguage();
            const targetLang = currentLang === LANGUAGES.FR ? LANGUAGES.EN : LANGUAGES.FR;

            console.info('Weglot not available. Using localStorage fallback for local dev.');
            localStorage.setItem('wglang', targetLang);
            window.location.reload();
        });
    }


    private setActiveNavItem(): void {
        const currentPath = window.location.pathname;
        const aList = this.querySelectorAll('a');

        aList.forEach(a => {
            const href = a.getAttribute('href');
            if (href) {
                // Handle home page case
                if (currentPath === '/' && href === '/') {
                    a.classList.add('active');
                }
                // Handle other pages
                else if (currentPath.includes(href) && href !== '/') {
                    a.classList.add('active');
                }
            }
        });
    }
}